@if (chevronKind === 'up') {
    <i class="theme-arrow-down theme-arrow-up"></i>
}
@if (chevronKind === 'down') {
    <i class="theme-arrow-down"></i>
}
